import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { login } from '../../Services/Auth';
import { useAuthStore } from '../../Stores/useAuthStore';
import { ROLES } from '../../Types/constants';
import * as paths from '../../Routing/paths';
import { Loader } from '../../Components/Loader/Loader';

const AppWrapper = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, setLoading, loading } = useAuthStore();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const handleRedirect = async () => {
      setLoading(true);
      try {
        const scope = process.env.REACT_APP_AZURE_SCOPE as string;
        const result = await instance.handleRedirectPromise();
        const account = result?.account || instance.getAllAccounts()[0];

        if (!account) {
          console.log('🔄 No account found. Redirecting to login...');
          await instance.loginRedirect({ scopes: [scope] });
          return;
        }

        const tokenResponse = await instance.acquireTokenSilent({
          scopes: [scope],
          account,
        });

        const accessToken = tokenResponse.accessToken;
        useAuthStore.setState({ accessToken });

        setUser(await login());
        const user = useAuthStore.getState().user;

        if (location.pathname === paths.HOME || location.pathname === '/') {
          if (user?.isAdmin || user?.isRecruiter) {
            navigate(paths.JOBS, { replace: true });
          }
          else if (user?.isInternal || user?.isOperations) {
            navigate(paths.PLANNER, { replace: true });
          } else {
            navigate(paths.JOBS, { replace: true });
          }
        }
      } catch (err: any) {
        console.error('🛑 MSAL redirect or backend login error:', err);
      } finally {
        setInitialized(true);
        setLoading(false);
      }
    };

    handleRedirect();
  }, [instance, navigate, setUser, setLoading, location.pathname]);

  if (loading || !initialized) {
    return <Loader isLoading={true} />;
  }

  return null;
};

export default AppWrapper;
